var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"care-logo align-right"},[_c('div',{staticClass:"care-logo__image"},[_c('Logo',{attrs:{"alt":_vm.$t('subheader.careLogo.imageAlt')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }